import { iProductOverview } from "store/types/subscriptionOrder"
import { BASE_API } from "../urlPaths"
import reqProvider from '../coreRequests'
import { call } from "redux-saga/effects"

export function* getAvailableProducts() {
  const path = `${BASE_API}/products`
  const data: iProductOverview = yield call(reqProvider.getReq, path)
  return data
}